import React from 'react';
import { useIntl } from 'react-intl';
import { PiArrowLeft, PiDownloadSimple } from 'react-icons/pi';
import { messages } from '../messages';
import { renderName, saveImage } from './saveImage';
import { ResultActions, ResultButton, ResultImage, ResultLayer } from './AiRender.styled';

export interface AiRenderResultProps {
  image: string;
  fileName?: string;
  onBack: () => void;
}

/** The rendered picture in place of the 3D view, which waits underneath. */
const AiRenderResult: React.FC<AiRenderResultProps> = ({ image, fileName, onBack }) => {
  const intl = useIntl();
  return (
    <ResultLayer data-testid="model-viewer__ai-result">
      <ResultImage src={image} alt={intl.formatMessage(messages.aiResult)} />
      <ResultActions>
        <ResultButton
          type="button"
          onClick={() => saveImage(image, renderName(fileName))}
          data-testid="model-viewer__ai-download"
        >
          <PiDownloadSimple />
          {intl.formatMessage(messages.aiDownload)}
        </ResultButton>
        <ResultButton type="button" onClick={onBack} data-testid="model-viewer__ai-back">
          <PiArrowLeft />
          {intl.formatMessage(messages.aiBack)}
        </ResultButton>
      </ResultActions>
    </ResultLayer>
  );
};

export default AiRenderResult;
